module.exports = __webpack_public_path__ + "img/img20.a7d6730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img20.png
// module id = 176
// module chunks = 0